import React from 'react';
import Calendar from '../calendar/calendar';
import { useParams, useHistory } from 'react-router-dom';

export default function MemberCalendar() {
  let { id } = useParams();

  return <Calendar memberId={id} />;
}
